import { type MutationHookOptions, useMutation } from "@apollo/client";
import { SignInMutation } from "./../graphql/mutations";

export const useSignIn = (options?: MutationHookOptions) => {
  return useMutation(SignInMutation, options);
};
